<template>
  <div>
    <page-header>
      <template #title>
        <h1 class="page-title">Credit Hire</h1>
      </template>
      <template #actions>
        <page-header-action @click.prevent="goBack">
          Back To Incident Details
        </page-header-action>
      </template>
    </page-header>
    <div class="row">
      <div class="col-lg-6">
        <div class="card mb-3">
          <div class="card-heading">
            Vehicle Hire Agreement
          </div>
          <div class="card-preview text-center">
            <transition name="component-fade">
              <div class="processing-overlay" v-if="refresh">
                Regenerating Document...
              </div>
            </transition>
            <div class="approved-overlay"></div>
            <img
              class="img-fluid"
              alt="Vehicle Hire Agreement"
              :src="vehicleHireAgreementThumb"
            />
          </div>
          <div class="card-controls">
            <a
              target="_blank"
              class="btn btn-block btn-dark btn-large-padding"
              :href="vehicleHireAgreementPath"
              >View Document</a
            >
            <a
              target="_blank"
              v-on:click.prevent="regenerateDocument"
              class="btn btn-block btn-primary no-margin btn-large-padding"
              >Regenerate Document</a
            >
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="card mb-3">
          <div class="card-heading">
            Vehicle Hire Details
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <table class="table-bordered table-striped table" v-if="hire">
              <tbody>
                <tr>
                  <th width="50%">Registration</th>
                  <td>
                    <span v-if="credit_hire">{{
                      credit_hire.vehicle.registration
                    }}</span>
                  </td>
                </tr>
                <tr>
                  <th width="50%">Start Date</th>
                  <td v-html="hireStartDate"></td>
                </tr>
                <tr>
                  <th width="50%">Daily Rate</th>
                  <td v-html="dailyRate"></td>
                </tr>
                <tr>
                  <th width="50%">Collision Damage Waiver</th>
                  <td v-html="collisionDamageWaiver"></td>
                </tr>
                <tr>
                  <th width="50%">Automatic</th>
                  <td v-html="automatic"></td>
                </tr>
                <tr>
                  <th width="50%">
                    Additional Drivers ({{ totalAdditionalDrivers }})
                  </th>
                  <td v-html="additional"></td>
                </tr>
                <tr>
                  <th width="50%">Estate</th>
                  <td v-html="estate"></td>
                </tr>
                <tr>
                  <th width="50%">Other</th>
                  <td v-html="other"></td>
                </tr>
                <tr>
                  <th width="50%">Total Daily Rate</th>
                  <td v-html="totalDailyRate"></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from './../Shared/PageHeader.vue';
import PageHeaderAction from './../Shared/PageHeaderAction.vue';

export default {
  components: {
    PageHeader,
    PageHeaderAction
  },

  props: {
    incident: {
      type: String,
      required: true
    },
    hire: {
      type: String
    },
    party: {
      type: String
    }
  },

  data() {
    return {
      proceeding: false,
      referringToAgent: false,
      credit_hire: null,
      refresh: false,
      documents: []
    };
  },

  computed: {
    additional() {
      if (this.credit_hire) {
        return `&pound;${this.penceToPounds(
          this.credit_hire.vehicle.rates.additional
        )} per driver`;
      }

      return null;
    },

    totalAdditionalDrivers() {
      if (this.credit_hire) {
        return this.credit_hire.drivers.filter(driver => {
          return driver.type_id !== 1;
        }).length;
      }

      return null;
    },

    totalDailyRate() {
      if (this.credit_hire) {
        return `&pound;${this.penceToPounds(
          this.credit_hire.vehicle.rates.total_daily_rate
        )}`;
      }

      return null;
    },

    other() {
      if (this.credit_hire) {
        return `&pound;${this.penceToPounds(
          this.credit_hire.vehicle.rates.other
        )}`;
      }

      return null;
    },

    estate() {
      if (this.credit_hire) {
        return `&pound;${this.penceToPounds(
          this.credit_hire.vehicle.rates.estate
        )}`;
      }

      return null;
    },

    automatic() {
      if (this.credit_hire) {
        return `&pound;${this.penceToPounds(
          this.credit_hire.vehicle.rates.automatic
        )}`;
      }

      return null;
    },

    collisionDamageWaiver() {
      if (this.credit_hire) {
        return `&pound;${this.penceToPounds(
          this.credit_hire.vehicle.rates.collision_damage_waiver
        )}`;
      }

      return null;
    },

    dailyRate() {
      if (this.credit_hire) {
        return `&pound;${this.penceToPounds(
          this.credit_hire.vehicle.rates.daily
        )}`;
      }

      return null;
    },

    hireStartDate() {
      if (this.credit_hire) {
        return this.formatDate(this.credit_hire.vehicle.start_date);
      }

      return null;
    },

    vehicleHireAgreementThumb() {
      let document = this.documents.find(document => {
        return document.hash;
      });

      if (!this.refresh && document) {
        return `${window.AxisUK.storage}${document.thumb}`;
      }

      return null;
    },

    vehicleHireAgreementPath() {
      let document = this.documents.find(document => {
        return document.hash;
      });

      if (!this.refresh && document) {
        return `${window.AxisUK.storage}${document.hash}`;
      }

      return null;
    }
  },

  mounted() {
    window.Ajax.get(
      `/incidents/${this.incident}/parties/${this.party}/hires/${this.hire}`
    )
      .then(response => {
        this.credit_hire = response.data;
        this.documents = response.data.documents;
      })
      .catch(error => {});
  },

  methods: {
    regenerateDocument() {
      this.refresh = true;

      setTimeout(() => {
        window.Ajax.post('/hires/' + this.hire + '/complete')
          .then(response => {
            this.refresh = false;
            window.toastify.success(
              'Regenerated',
              'The document was regenerated successfully!'
            );
          })
          .catch(error => {
            this.refresh = false;
            window.toastify.error(
              'Error',
              'Sorry, we could not regenerate the document for you'
            );
          });
      }, 1000);
    },

    goBack() {
      this.$router.back();
    }
  }
};
</script>
